/** Detetmine if the supplied element is a valid Dom Element */
function isPositionalElement(element) {
    if (!element) return false;
    return element instanceof Element || element instanceof HTMLDocument;
}
/** Convert DomRect to cloned primative object */
const domRectToObject = (element) => {
    const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect();
    return { top, right, bottom, left, width, height, x, y };
};

const getRelativeBoundingClientRect = (domElement, refereceDomElement) => {
    const rect = domRectToObject(domElement); //Object.assign({}, ...domElement.getBoundingClientRect());
    const refRec = domRectToObject(refereceDomElement);
    rect.x = rect.x - refRec.x;
    rect.y = rect.y - refRec.y;
    return rect;
};

/** Point is within specified rectanlge
 * x,y are mouse point coordinates
 * rect is and objec with x,y,width,height values, the easiest way is to use the result of getBoundingClientRect on a dom element
 * padding: allows the collision to return true when outside the rect but within entra distance around the rect
 */
const pointWithinRectangle = (x, y, rect, padding = 0) => {
    // console.log(':x', x, rect.x, rect.width, '::', x >= rect.x - padding && x <= rect.x + rect.width + padding);
    let withinX = x >= rect.x - padding && x <= rect.x + rect.width + padding;
    let withinY = y >= rect.y - padding && y <= rect.y + rect.height + padding;
    return withinX && withinY;
};
export { pointWithinRectangle };

/** Point specified is within a domElement's bounding rectangle
 * same as pointWithinRectangle but with domElement validation
 */
const pointWithinDomElement = (x, y, domElement, padding = 0, referenceDomElement = null) => {
    if (!isPositionalElement(domElement)) return false;
    const rect = referenceDomElement ? getRelativeBoundingClientRect(domElement, referenceDomElement) : domElement.getBoundingClientRect();
    // console.log(referenceDomElement, getRelativeBoundingClientRect(domElement, referenceDomElement), domElement.getBoundingClientRect());
    return pointWithinRectangle(x, y, rect, padding);
};
export { pointWithinDomElement };
